const tagRoute = [
  {
    path: '/tags',
    name: 'TagList',
    component: () => import('@/views/tag/TagList.vue'),
    authed: 'MEC_TAG',
    meta: {
      tabName: 'Tag List',
      title: 'Tag List',
      group: 'Tag Mgmt.',
      icon: 'mdiTagMultiple',
      groupSort: 35,
    },
  },
  {
    path: '/tags/:tagId',
    name: 'TagDetails',
    component: () => import('@/views/tag/TagDetails.vue'),
    authed: 'MEC_TAG',
    meta: {
      tabName: 'Tag Details',
      title: 'Tag Details',
      group: 'Tag Mgmt.',
      isHide: true,
    },
  },
]

export default tagRoute
